export default function Component$findNextNode () {
	return this.parentFragment.findNextNode( this );
}
